export interface CommentsQuestion {
  questionTextResourceName: string;
  questionResponses: string[];
}
